import { IAlertConfig } from '../../../models/bootstrap/Alert'


export class MetaformCacheController {

    forms: string[] = [];
    filter: string = '';
    loading: boolean = false;
    alerts: IAlertConfig[] = [];

    static $inject = ['MetaformCache', 'dialogs'];
    constructor(private MetaformCache, private dialogs) {
        this.refresh();
    }

    refresh() {
        this.loading = true;

        this.MetaformCache.forms().$promise
            .then((result) => {
                this.forms = result;
            }, () => {
                this.showError('We are sorry but the list of metaforms cannot be loaded.');
            })
            .finally(() => {
                this.loading = false;
            });
    }

    filteredForms() {
        const filter = (this.filter || '').toLowerCase();
        return filter ? this.forms.filter((form) => form.toLowerCase().indexOf(filter) >= 0) : this.forms;
    }

    clearAll() {
        this.dialogs.confirm('Please Confirm', 'Are you sure that you wish to clear the cache of all metaforms?')
            .result
            .then(() => {
                this.MetaformCache.clearAll().$promise.then(
                    () => this.showSuccess('Cache of all metaforms has been cleared'),
                    () => this.showError('We are sorry but the metaform cache cannot be cleared.'));
            });
    }

    clearForm(formName: string) {
        this.dialogs.confirm('Please Confirm', `Are you sure that you wish to clear the cache of '${formName}' metaform?`)
            .result
            .then(() => {
                this.MetaformCache.clearForm({ formName: formName }).$promise.then(
                    () => this.showSuccess(`Cache of '${formName}' metaform has been cleared`),
                    () => this.showError(`We are sorry but the cache of '${formName}' metaform cannot be cleared.`));
            });
    }

    closeAlert(index: number) {
        this.alerts.splice(index, 1);
    }

    private showSuccess(msg: string) {
        this.alerts.push({ type: 'success', msg: msg, dismissOnTimeout: 5000 });
    }

    private showError(msg: string) {
        this.alerts.push({ type: 'danger', msg: msg, dismissOnTimeout: 5000 });
    }
}


angular
    .module('app')
    .controller('MetaformCacheController', MetaformCacheController);
